type IntervalUnit = 'm' | 'h' | 'd';

type ParsedInterval = {
  amount: number;
  unit: IntervalUnit;
} | null;

export function parseInterval(value: string): ParsedInterval {
  const match = value.match(/^(\d+)([mhd])$/);
  if (!match) return null;

  return {
    amount: parseInt(match[1], 10),
    unit: match[2] as IntervalUnit
  };
}

export function subtractIntervalFromDate(
  date: Date,
  interval: ParsedInterval
): Date {
  if (!interval) return date;

  const result = new Date(date);

  switch (interval.unit) {
    case 'm':
      result.setMinutes(result.getMinutes() - interval.amount);
      break;
    case 'h':
      result.setHours(result.getHours() - interval.amount);
      break;
    case 'd':
      result.setDate(result.getDate() - interval.amount);
      break;
    default:
      break;
  }

  return result;
}
